module.exports = __webpack_public_path__ + "img/tier1_pic1.793a6760.png";